export var capitalize = function (value) { return value.charAt(0).toUpperCase() + value.slice(1); };
export var lowercase = function (value) { return value.charAt(0).toLowerCase() + value.slice(1); };
export var splitOnUpperCase = function (value) { return value.match(/([A-Z]?[^A-Z]*)/g).slice(0, -1); };
export var pascalSentenceFromString = function (value) {
    return splitOnUpperCase(value)
        .map(capitalize)
        .join(" ");
};
export var camelSentenceFromString = function (value) {
    return capitalize(splitOnUpperCase(value)
        .map(lowercase)
        .join(" "));
};



//////////////////
// WEBPACK FOOTER
// ./src/utils/stringUtils.ts
// module id = 261
// module chunks = 3